function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';
import { useAction } from 'hooks';
import Button from 'components/Form/Button';
import ArrowDownNegative from 'svg/arrow-down-negative.svg';
import App from 'modules/App';
import Account from 'modules/Account';
import * as constants from '../../constants';
import messages from '../../messages';
import styles from './DownloadDataFromMeterBtn.pcss';
const ApprovalBtnPlaceholder = ({ className })=>/*#__PURE__*/ _jsx(Button, {
        className: cn(styles.root, styles['root--notActive'], className),
        isDisabled: true,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "d-flex align-items-center",
            style: {
                flexWrap: 'nowrap'
            },
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-auto pr-0",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: cn(styles.icon, styles['icon--notActive']),
                        children: /*#__PURE__*/ _jsx(ArrowDownNegative, {
                            className: styles.icon__arrow
                        })
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col",
                    children: /*#__PURE__*/ _jsx("p", {
                        className: cn(styles.label, styles['label--lead'], styles['label--notActive']),
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.buttons.waitForApproval))
                    })
                })
            ]
        })
    });
const DownloadDataBtn = ({ className, styleModifier, isDisabled, isReadOnly })=>{
    const devices = useSelector(App.selectors.devices);
    const isBtnDisabled = isReadOnly || isDisabled || !devices || !devices.length;
    const onOpenModal = useAction(App.actions.openModal, constants.DOWNLOAD_DATA_MODAL);
    return /*#__PURE__*/ _jsx(Button, {
        id: "meterDownloadData",
        styleModifier: styleModifier,
        className: cn(styles.root, {
            [styles['root--notActive']]: isReadOnly
        }, className),
        isDisabled: isBtnDisabled,
        onClick: onOpenModal,
        children: /*#__PURE__*/ _jsxs("div", {
            className: cn(styles.content, 'row'),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-auto pr-0",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: cn(styles.icon__wrapper),
                        children: /*#__PURE__*/ _jsx("div", {
                            className: cn(styles.icon, {
                                [styles['icon--notActive']]: isReadOnly
                            }),
                            children: /*#__PURE__*/ _jsx(ArrowDownNegative, {
                                className: styles.icon__arrow
                            })
                        })
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "col w-100",
                    children: [
                        /*#__PURE__*/ _jsx("p", {
                            className: cn(styles.label, styles['label--lead']),
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.buttons.downloadData))
                        }),
                        /*#__PURE__*/ _jsx("p", {
                            className: cn(styles.label, styles['label--secondary']),
                            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.buttons.fromMeter))
                        })
                    ]
                })
            ]
        })
    });
};
const DownloadDataFromMeterBtn = ({ className = 'btn--block btn--filled m-0', styleModifier = 'primary', isDisabled = false, isReadOnly = false })=>{
    const activeProfileType = useSelector(Account.selectors.activeProfileType);
    const activeClinicMembership = useSelector(Account.selectors.activeClinicMembership);
    useStyles(styles);
    if (activeProfileType === Account.constants.PROFILE_TYPES.HCP && (!activeClinicMembership || activeClinicMembership.membershipStatus === 'Pending' || activeClinicMembership.clinic.clinicStatus === 'Pending')) {
        return /*#__PURE__*/ _jsx(ApprovalBtnPlaceholder, {
            className: className
        });
    }
    return /*#__PURE__*/ _jsx(DownloadDataBtn, {
        className: className,
        styleModifier: styleModifier,
        isDisabled: isDisabled,
        isReadOnly: isReadOnly
    });
};
export default DownloadDataFromMeterBtn;
